import { SelfStudyDetailSummaryDetailTable } from './components/SelfStudyDetailSummaryDetailTable';

interface GraphAreaProps {
  summaryDetailTableData: any[];
  summaryItemId: number | 0;
}

const GraphAreaStudyDetail: React.FC<GraphAreaProps> = ({
  summaryDetailTableData,
  summaryItemId,
}) => {
  return (
    <>
      <div className="mt-[70px] min-h-min min-w-min">
        <SelfStudyDetailSummaryDetailTable
          data={summaryDetailTableData}
          summaryItemId={summaryItemId}
        ></SelfStudyDetailSummaryDetailTable>
      </div>
    </>
  );
};
export { GraphAreaStudyDetail };
